export enum ModellingKind {
  Instance = 'Instance',
  Template = 'Template',
}
